import { render, staticRenderFns } from "./ExploreRisk.vue?vue&type=template&id=21f3661a&scoped=true"
import script from "./ExploreRisk.vue?vue&type=script&lang=js"
export * from "./ExploreRisk.vue?vue&type=script&lang=js"
import style0 from "./ExploreRisk.vue?vue&type=style&index=0&id=21f3661a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f3661a",
  null
  
)

export default component.exports